<template>
  <v-card elevation="2" style="width: 500px; border-radius: 0">

    <v-card-title class="rep-title blue-text" style="font-weight: bold;">
      <v-icon color="green">mdi-check</v-icon><span style="margin-left: 5px">VERIFICATION COMPLETED</span>
    </v-card-title>
    <v-btn class="close-btn" fab @click="resetSession">
      <v-icon rightb style="color: white; padding-left: 2px; font-size: 13pt">mdi-close</v-icon>
    </v-btn>
    <div v-show="reports.length > 1">
      <div style="display: flex; align-items: center; margin-top: -10px; margin-bottom: -20px;">
        <div ref="chartEL" class="chart" style="width:200px; height: 200px" />
        <div>
          <div class="rep-category">
            <div class="cat-box" style="background: none"></div>
            <span class="med-text" style="font-weight: bold">TOTAL - </span>
            <span class="med-text" style="font-weight: bold">{{this.reports.length}}</span>
          </div>
          <div class="rep-category" v-for="(value, name) in this.categories" :key="name">
            <div class="cat-box" :style="{background: getColorForCategory(name)}"></div>
            <span class="med-text" style="font-weight: bold">{{name.toUpperCase()}} - </span>
            <span class="med-text" style="font-weight: bold" :style="{color: getColorForCategory(name)}">{{value}}</span>
          </div>
        </div>
      </div>
      <v-alert
              outlined
              border="left"
              type="info"
              color="yellow darken-3"
              style="margin: 0 20px; font-size: 10pt; text-align: left"
      >
        Please make sure to check the <strong>issuer's name</strong> after downloading the <strong>reports</strong>.
      </v-alert>
    </div>
    <div v-if="reports.length === 1">
      <div style="display: flex; align-items: flex-start; padding: 20px 20px;">
        <v-icon style="font-size: 30pt" :style="{color: getColorForCategory(reports[0]._status)}">mdi-{{getReportIcon(reports[0])}}</v-icon>
        <div style="text-align: left; margin-left: 10px" :style="{color: getColorForCategory(reports[0]._status)}">
          <div>{{isInvalidDocument(reports[0]) ? 'Invalid Certificate' : (isValidDocument(reports[0]) ? 'Valid Certificate':'Error')}}</div>
          <div style="color: #000"><b v-if="!isValidDocument(reports[0])">Reason:</b> <span v-html="tableData[0] && tableData[0].message"></span></div>
          <div v-if="!isValidDocument(reports[0])" style="color: #000; margin-top: 10px;">Please write to <a href="mailto:secretary@msbsd.edu.in">secretary@msbsd.edu.in</a> to report the problem.</div>
        </div>
      </div>
    </div>
    <v-card-actions style="display: flex; justify-content: space-between; margin: 5px 10px;">
      <highlight-button v-if="reports.length > 1" @click.native ="exportToXLSX"> <v-icon>mdi-microsoft-excel</v-icon> Excel Report</highlight-button>
      <highlight-button v-else-if="isValidDocument(reports[0]) && tableData[0]"><a style="text-decoration: none" :href="`https://polygonscan.com/tx/${tableData[0].txAddress}`" target="_blank"><v-icon>mdi-launch</v-icon> View on Blockchain</a></highlight-button>
      <highlight-button v-if="reports.length === 1 && isValidDocument(reports[0])" @click.native="reportDialog=true" color="green" style="margin-left: 10px"><v-icon>mdi-download</v-icon> Download Report</highlight-button>
      <highlight-button v-if="reports.length > 1" @click.native ="exportToText"> <v-icon>mdi-file-document-outline</v-icon> Text Report</highlight-button>
    </v-card-actions>


    <v-dialog
            v-model="reportDialog"
            width="unset"
            style="position: absolute !important; top: 0; "
    >
      <v-card>
        <address-request />
      </v-card>
    </v-dialog>
    <!--el-table
      :data="tableData"
      style="overflow: auto; min-height: 200px; max-width: calc(100vw - 70px); width: auto !important; align-self: stretch; flex:1 1 0"
      border
      empty-text="No data available"
      :cell-class-name="tableCellClassName"
      :header-cell-style="{background: '#f5f7fa'}"
    >
      <el-table-column
        prop="name"
        label="Name"
        sortable
      />
      <el-table-column
        prop="status"
        label="Status"
        sortable
        width="90"
        style="font-weight: bold;"
      />
      <el-table-column
        prop="message"
        label="Message">
        <template slot-scope="scope">
          <span style="font-weight: bold;">{{ scope.row.message }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="issueAuthority"
        label="Issued BY"
        sortable
      /-->
    <!--el-table-column
      label="Issue Date"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.issueTime !== 'N/A'">
          <i class="el-icon-time" />
          <span style="margin-left: 10px">{{ scope.row.issueTime.toDateString() }}</span>
        </div>
        <span v-else>N/A</span>
      </template>
    </el-table-column
    <el-table-column
      prop="txAddress"
      label="Blockchain transaction"
    >
      <template slot-scope="scope">
        <a v-if="scope.row.txAddress !== 'N/A'" :href="`https://etherscan.io/tx/${scope.row.txAddress}`" target="_blank" style="color:#68cbb0">
          <i class="el-icon-link" />
          Click to see on Blockchain
        </a>
        <span v-else>N/A</span>
      </template>
    </el-table-column>
  </el-table-->
  </v-card>
</template>

<script>

import { init as chartInit} from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import zipcelx from 'zipcelx';
import HighlightButton from "../../../components/HighlightButton";
import FileVerificationStatus from "@/store/support/verifier/FileVerificationStatus.js";
import AddressRequest from "../../home/comps/AddressRequest";

const colorMap = {
  valid: '#07ca94',
  invalid: '#ff3627',
  invalidated: '#cc2c22',
  error: '#cc8939'
};

export default {
  name: 'GeneratedReports',
  components: {AddressRequest, HighlightButton},
  data() {
    return {
      tableData: [],
      headerString: '',
      reportDialog: false
    };
  },
  computed: {
    reports() {
      return this.$store.state.verifier.stage.reports;
    },
    categories() {
      return this.$store.state.verifier.stage.categories;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initHeaderString();
    });
    this.$root.$on('generated-report', ()=>{
      this.reportDialog = false;
    });
    this.$root.$on('close-report-dialog', ()=>{
      this.reportDialog = false;
    });
  },
  methods: {
    initHeaderString() {
      this.headerString = `Total: ${this.reports.length}, ` + Object.keys(this.categories).map(catName => `${catName.toUpperCase()}: ${this.categories[catName]}`).join(', ');
      this.initReports();
    },
    initReports() {
      this.chart = chartInit(this.$refs['chartEL'], 'macarons');
      const data = [];
      const legends = [];
      for (const name in this.categories) {
        legends.push(name.toUpperCase());
        data.push({
          name: name.toUpperCase(), value: this.categories[name], itemStyle: { color: this.getColorForCategory(name.toLowerCase()) }});
      }
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          left: 'center',
          bottom: '10',
          data: legends
        },
        series: [
          {
            name: 'VERIFICATION REPORT',
            type: 'pie',
            radius: ['50%', '70%'],
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data,
            animationType: 'scale',
            animationEasing: 'cubicInOut',
            animationDuration: 1000
          }
        ]
      });
      this.initTableData();
    },
    getColorForCategory(catName) {
      return colorMap[catName] || '#4077cc';
    },
    initTableData() {
      for (let i = 0; i < this.reports.length; i++) {
        const report = this.reports[i];
        this.tableData.push({
          name: report._file.name,
          status: report._status.toUpperCase(),
          message: report._message || 'N/A',
          issueAuthority: report.issueAuthority || 'N/A',
          issueTime: report.issueTime ? new Date(report.issueTime * 1000) : 'N/A',
          txAddress: (report.qrCode && report.qrCode.t) || 'N/A'
        });
      }
    },
    getReportIcon(report) {
      switch(report._status) {
        case FileVerificationStatus.VALID: return 'file-check';
        case FileVerificationStatus.INVALID: return 'close-octagon';
        case FileVerificationStatus.INVALIDATED: return 'close-octagon';
        default: return 'alert-circle';
      }
    },
    isValidDocument(report) {
      return report._status === FileVerificationStatus.VALID;
    },
    isInvalidDocument(report) {
      switch(report._status) {
        case FileVerificationStatus.INVALID: return true;
        case FileVerificationStatus.INVALIDATED: return true;
        default: return false;
      }
    },
    didDocumentError(report) {
      return report._status === FileVerificationStatus.ERROR;
    },
    exportToText() {
      // Atleast one row must be present.
      if (!this.tableData[0]) {
        return;
      }
      let downloadText = '';
      const columnNames = Object.keys(this.tableData[0]);
      this.tableData.forEach((row) => {
        Object.keys(row).forEach((column, index) => {
          downloadText+= '['+columnNames[index]+'] '+row[column] +'--';
        });
        downloadText+='\r\n';
      });
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(new Blob([downloadText], {type: 'text/plain'}));
      a.download = `LGT-VERIFY-${this.$store.state.verifier.sessionUID}.txt`;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a)
    },
    exportToXLSX() {
      // Atleast one row must be present.
      if (!this.tableData[0]) {
        return;
      }
      const excelHeader = Object.keys(this.tableData[0]).map(columnName => ({
        value: columnName,
        type: 'string'
      }));
      const excelData = this.tableData.map((row) => {
        return Object.keys(row).map((column) => ({
          value: row[column],
          type: 'string'
        }));
      });
      excelData.unshift(excelHeader);
      const config = {
        filename: `LGT-VERIFY-${this.$store.state.verifier.sessionUID}`,
        sheet: {
          data: excelData
        }
      };
      zipcelx(config);
    },
    tableCellClassName({ row, columnIndex }) {
      if (columnIndex === 1) {
        if (colorMap[row.status.toLowerCase()]) {
          return `cst-${row.status.toLowerCase()}-cell`;
        }
        return 'cst-default-cell';
      }
    },
    resetSession() {
      this.reportDialog = false;
      this.$store.dispatch('verifier/resetVerification');
    }
  }
};
</script>

<style scoped lang="scss">
  @import "~@/styles/variables.scss";

  .close-btn {
    position: absolute; right: 10px; top: 10px; width: 30px !important; height: 30px !important;
    background: $primary-dark !important;
  }

  .rep-title {
    position: relative;
  }

  .mobile .rep-title {
    font-size: 13pt;
  }
  .rep-title:after {
    content:"";
    bottom:4px;
    left:0;
    position: absolute;
    width: 90%;
    height: 1px;
    background: $primary-text;
  }
  .cat-box {
    display: inline-block;
    width: 30px;
    height: 20px;
    border-radius: 3px;
  }
  .rep-category{
    text-align: left;
    display: flex;
    align-items: center;
  }

  .rep-category *:not(:first-child){
    margin-left: 5px;
  }
  .report-card {
    background: rgb(255,255,255,0.8);
  }
</style>

<style>
    .cst-error-cell {
        background: #cc89391f !important;
    }
    .cst-invalid-cell {
        background: #cc2c221f;
    }
    .cst-invalidated-cell {
      background: #ff36271f;
    }
    .cst-valid-cell {
        background: #07ca941f !important;
    }
    .cst-default-cell {
        background: #4077cc1f;
    }
</style>
